import React from 'react';
import { preprocessLines } from './preprocess';

function fmtInline(s) {
  return s
    .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
    .replace(/\*([^*\n]+?)\*/g, '<em>$1</em>')
    .replace(/`([^`\n]+)`/g, '<code>$1</code>');
}

const tdStyle = { padding: '8px 12px', border: '1px solid rgba(46,196,182,0.15)', color: '#c8d5e4', verticalAlign: 'top' };
const thStyle = { background: 'rgba(46,196,182,0.12)', color: '#2ec4b6', textAlign: 'left', padding: '8px 12px', fontSize: 11, fontWeight: 700, textTransform: 'uppercase', border: '1px solid rgba(46,196,182,0.2)' };

export default function MdView({ text }) {
  const lines = preprocessLines(text.split('\n'));
  const out = [];
  let i = 0;
  let k = 0;

  while (i < lines.length) {
    const line = lines[i];

    // Table
    if (line.startsWith('|') && lines[i + 1] && /^\|[-: |]+\|/.test(lines[i + 1])) {
      const heads = line.split('|').slice(1, -1).map(h => h.trim());
      i += 2;
      const rows = [];
      while (i < lines.length && lines[i].startsWith('|')) {
        rows.push(lines[i].split('|').slice(1, -1).map(c => c.trim()));
        i++;
      }
      out.push(
        <div key={k++} style={{ overflowX: 'auto', margin: '14px 0' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
            <thead><tr>{heads.map((h, j) => <th key={j} style={thStyle}>{h}</th>)}</tr></thead>
            <tbody>{rows.map((row, ri) => (
              <tr key={ri}>{row.map((cell, ci) => (
                <td key={ci} style={tdStyle} dangerouslySetInnerHTML={{ __html: fmtInline(cell) }} />
              ))}</tr>
            ))}</tbody>
          </table>
        </div>
      );
      continue;
    }

    if (line.startsWith('#### ')) out.push(<h4 key={k++} style={{ fontSize: 13, fontWeight: 700, color: '#f5f0e8', margin: '16px 0 5px' }} dangerouslySetInnerHTML={{ __html: fmtInline(line.slice(5)) }} />);
    else if (line.startsWith('### ')) out.push(<h3 key={k++} style={{ fontSize: 12, fontWeight: 700, color: '#f4c842', margin: '22px 0 6px', textTransform: 'uppercase', letterSpacing: '.6px' }} dangerouslySetInnerHTML={{ __html: fmtInline(line.slice(4)) }} />);
    else if (line.startsWith('## ')) out.push(<h2 key={k++} style={{ fontFamily: 'Georgia,serif', fontSize: 18, fontWeight: 700, color: '#2ec4b6', margin: '32px 0 12px', paddingBottom: 8, borderBottom: '1px solid rgba(46,196,182,0.2)' }} dangerouslySetInnerHTML={{ __html: fmtInline(line.slice(3)) }} />);
    else if (line.startsWith('# ')) out.push(<h1 key={k++} style={{ fontFamily: 'Georgia,serif', fontSize: 24, fontWeight: 700, color: '#f5f0e8', margin: '0 0 6px' }} dangerouslySetInnerHTML={{ __html: fmtInline(line.slice(2)) }} />);
    else if (/^---+$/.test(line.trim())) out.push(<hr key={k++} style={{ border: 'none', borderTop: '1px solid rgba(46,196,182,0.18)', margin: '28px 0' }} />);

    else if (/^\s*[-*]\s+/.test(line) || /^\s*\d+\.\s+/.test(line)) {
      const items = [];
      while (i < lines.length && (/^\s*[-*]\s+/.test(lines[i]) || /^\s*\d+\.\s+/.test(lines[i]))) {
        const txt = lines[i].replace(/^\s*[-*]\s+/, '').replace(/^\s*\d+\.\s+/, '');
        items.push(<li key={i} style={{ marginBottom: 6, color: '#c8d5e4', lineHeight: 1.7 }} dangerouslySetInnerHTML={{ __html: fmtInline(txt) }} />);
        i++;
      }
      out.push(<ul key={k++} style={{ paddingLeft: 20, marginBottom: 14 }}>{items}</ul>);
      continue;
    }

    else if (line.trim()) out.push(<p key={k++} style={{ color: '#c8d5e4', lineHeight: 1.75, marginBottom: 10 }} dangerouslySetInnerHTML={{ __html: fmtInline(line) }} />);

    i++;
  }

  return <>{out}</>;
}
